
    "use strict";

    import hotkeys from 'hotkeys-js';

    let $ = window.jQuery;
    require('jquery-touchswipe');

    export class Gallery {

        constructor($options) {

            let $defaults = {
                pushState: false,
                checkMargin: false,
                container: null,
                context: 'page',
                position: 0,
                history: {}
            };

            $options = $.extend($defaults, $options);

            this.debug = true;
            this.flagCheckMargin = $options.checkMargin ? $options.checkMargin : false;

            this.context = $options.context;
            this.selectorCounter = '.gallery--count';
            this.selectorCollection = '.entry-attachment img';
            
            this.counter = null;
            this.facade = $options.position;
            this.position = $options.position;
            this.image = null;
            this.history = $options.history;

            this.container = $options.container ? $options.container : $('body');
            this.collection = $(this.selectorCollection, this.container);

            if(this.collection.length > 0) {
                this.prepare();
                this.listen();
                this.run();
            }

        }

        getHeaderHeight() {

            let $check = [
                '#wpadminbar',
                '#masthead'
            ];

            let $margin_top = 0;
            $.each($check, function() {
                var $this = $(this);
                if($this.is(':visible')) {
                    $margin_top += $this.outerHeight(true);
                }
            });

            return $margin_top;

        }

        prepare() {

            this.checkMargin();

            this.image = this.getImage(this.position);

            if(window.location.hash) {
                var $position = window.location.href.split('#')[1];
                $position = parseInt($position);
                let $notsafe = 1;
                this.bound($position, $notsafe);
            }
            
            this.counter = $(this.selectorCounter, this.container);
            this.updateCounter();

            this.check();

        }

        /** 
         * Check if we should even display the navigation.
         */
        check() {
            if(this.collection.length <= 1) {
                $('.entry-header', this.container).css('opacity', 0);
            }
        }

        run() {
            this.container.addClass('gallery--initialized');
            this.image.css({'opacity': 1, 'display': 'block'});
            this.toggleContent();
        }

        counterHtml() {
            return (this.facade + 1) + '/' + this.collection.length;
        }

        photoCreditHtml($options) {
            var $output = [];
            if($options.text) {
                $output.push('<div class="photo-credit"><p class="photo-credit--text">');
                $output.push('');
                if($options.link) {
                    $output.push('<a href="' + $options.link +'">' + $options.text + '</a>');
                } else {
                    $output.push($options.text);
                }
                $output.push('</p></div>');
            }
            return $output.join("\n");
        }
        
        listen() {

            // browser

            $(window).resize(() => {
                this.resize();
            });

            // clicks

            $('.gallery-nav--previous', this.container).click(($evt) => {
                $evt.preventDefault();
                this.go(-1);
            });

            $('.gallery-nav--next', this.container).click(($evt) => {
                $evt.preventDefault();
                this.go(1);
            });

            $('.x-close', this.container).click(($evt) => {
                $evt.preventDefault();
                this.close();
            });

            // keyboard shortcuts

            hotkeys('esc', ($evt) => {
                $evt.preventDefault();
                this.close();
            });

            hotkeys('left', ($evt) => {
                $evt.preventDefault();
                this.go(-1);
            });

            hotkeys('right',($evt, $handler) => {
                $evt.preventDefault();
                this.go(1);
            });

            // swipe
            this.collection.swipe({
                threshold: 10,
                swipeLeft: () => {
                    this.go(-1);
                },
                swipeRight: () => {
                    this.go(1);
                },
                swipeUp: () => {
                    this.close();
                }
            });

        }

        close() {
            $(document).trigger('gallery--close', [this.context]);
            if(this.context != 'page') {
                // unbind
                hotkeys.unbind('left');
                hotkeys.unbind('right');
                // close out
                this.container.remove();
            }
        }

        checkMargin() {
            if(this.flagCheckMargin) {
                var $margin_top = this.getHeaderHeight();
                this.container.css('margin-top', $margin_top+'px');
            }
        }

        resize() {
            this.checkMargin();
            return this;
        }

        go($direction) {
            this.bound(this.facade + $direction);
            this.change();
        }

        updateCounter() {
            this.counter.html(this.counterHtml());
            return this;
        }

        bound($position, $notsafe) {
            if($position >= this.collection.length) {
                this.facade = this.position = 0;
            } else if($position < 0) {
                this.facade = this.position = this.collection.length - 1;
            } else {
                this.facade = $position;
                if(!$notsafe) {
                    this.position = $position;
                }
            }
            return this;
        }

        getImage($position) {
            return $(this.collection.get($position));
        }

        change() {
            this.updateCounter();
            this.toggleImage();
            this.toggleContent();
            if(this.options.pushState) {
                this.pushState();
            }
            return this;
        }

        // NOTE: must use this.postion and not this.facade
        toggleImage() {
            this.image.css({'opacity': 0, 'display': 'none'});
            this.image = this.getImage(this.position);
            this.image.css({'opacity': 1, 'display': 'inline-block'});
            return this;
        }

        toggleContent() {
            $('.entry-content', this.container).html(this.image.data('caption'));
            $('.entry-footer', this.container).html(this.photoCreditHtml({text: this.image.data('photo-credit'), link: this.image.data('photo-credit-link')}));
        }

        pushState() {
            this.image.data('permalink')
                && history 
                && history.pushState 
                && history.pushState({position: this.position}, 'Attachment #'+this.position, this.image.data('permalink')+'#'+this.position);
            return this;
        }

    };



// WEBPACK FOOTER //
// ./tbo/js/widget/gallery.js